export const ANALYTICS_DEFAULT_DECIMAL_PRECISIONS = 0
